"use client";

import { ILeanProductTile } from "@faire/web-api/indigofair/data/ILeanProductTile";
import React, { useMemo } from "react";

import { useSDUIOnClickHandler } from "@faire/retailer/components/SDUI/__internal__/ActionHandler/useSDUIOnClickHandler";
import {
  useGenerateBrandUrlForSDUIProductTileHandler,
  useGenerateProductLinkPropsForSDUIProductTileHandler,
} from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/__internal__/ProductTile/SDUIProductTileUrlHandler";
import { SDUITileInstanceRendererProps } from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/__internal__/types";
import { MarketplaceProduct } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/MarketplaceProduct";

export const SDUIProductTileWithBrand = ({
  tileElement,
  loggingData,
  renderBehaviour,
}: SDUITileInstanceRendererProps) => {
  const { on_click } = tileElement;
  const { product, brand } = tileElement.product_with_brand_info_tile ?? {};
  const brandTile = useMemo(
    () =>
      ILeanProductTile.IBrand.build({
        ...brand,
      }),
    [brand]
  );
  const generateProductLinkProps =
    useGenerateProductLinkPropsForSDUIProductTileHandler(
      product,
      loggingData.view_display_page
    );
  const generateBrandUrl = useGenerateBrandUrlForSDUIProductTileHandler(
    product,
    loggingData.view_display_page
  );

  const brandClickLoggingData = useMemo(() => {
    return {
      ...loggingData,
      action_instance_identifier: brandTile?.token,
    };
  }, [loggingData, brandTile]);

  const onBrandClickHandler = useSDUIOnClickHandler(
    on_click,
    brandClickLoggingData,
    { logSDUIClickEvent: true, logLegacyClickEvent: true }
  );
  const onProductClickHandler = useSDUIOnClickHandler(on_click, loggingData, {
    logSDUIClickEvent: true,
    logLegacyClickEvent: true,
  });

  if (product === undefined || brand === undefined) {
    return null;
  }
  return (
    <MarketplaceProduct
      tileIndex={Number(loggingData.action_positions ?? -1)}
      productTile={product}
      brand={brandTile}
      generateProductLinkProps={generateProductLinkProps}
      generateBrandUrl={generateBrandUrl}
      useLazyImageLoading={renderBehaviour?.imagesLoadingStrategy === "lazy"}
      onClick={onProductClickHandler}
      onBrandClick={onBrandClickHandler}
      recordAdImpression
    />
  );
};
